/** A status pill led by a colored dot, for states with no {@link StatusPill} tone. */
export function DotPill({
  label,
  color,
  background,
}: {
  label: string;
  color: string;
  background: string;
}) {
  return (
    <span
      className="nb-pill"
      style={{
        height: 20,
        fontSize: 10.5,
        padding: '0 7px',
        gap: 5,
        background,
        color,
        borderColor: 'transparent',
      }}
    >
      <i className="nb-pill-dot" style={{ background: 'currentColor' }} aria-hidden="true" />
      {label}
    </span>
  );
}
